export const REQEXP_ONLY_NUMBERS = /^[0-9]+$/gi
